module.exports = __webpack_public_path__ + "img/icon-line.de663194.svg";